import styled from '@emotion/styled';

export const StyledConsignedCard = styled.div`
  border-radius: 15px;
  border: 2px solid #E6E5EA;
  margin-bottom: 1rem;
  width: 100%;
`;

export const StyledHeader = styled.div`
  min-height: 5rem;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  width: 100%;
  padding: 1rem 1rem 0rem 1rem;
`;

export const StyledTitle = styled.div`
  color: ${({ theme }) => theme.palette?.brand.primary.base};
  font-family: 'Urbanist';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
`;
